var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page__app",attrs:{"id":"app"}},[_c('PageNav'),_c('main',{staticClass:"page__main"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }